<!-- 更新日志 -->
<template>
  <div class="menu-item-r">
    <div class="bl-container">
      <div class="version">
        <div class="calendar-view">
            <el-calendar v-model="value"></el-calendar>
        </div>
        <div class="content-view">
          <div class="content-card" v-for="(item, index) in logList" :key="index">
            <div class="title">
              <span>{{item.date}}</span>
              &nbsp;&nbsp;
              <span>{{item.time}}</span>
            </div>
            <div class="content"><p v-html="item.log"></p></div>
          </div>
          <div class="content-card" v-if="logList.length == 0">
            <div class="title">{{key}}</div>
            <div class="content">{{$t('common.noData')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import logs from './versionLog.json'

export default {
  data () {
    // 这里存放数据
    return {
      key: '',
      logs: logs,
      logList: [],
      value: new Date()
    }
  },
  watch: {
    value: function() {
        this.init(this.value)
    }
  },
  // 方法集合
  methods: {
    changeDay(d) {
      var key = d.year + '.' + d.month + '.' + d.day;
      this.key = key;
      if(!Object.prototype.hasOwnProperty.call(this.logs, key)) {
        this.logList = [];
        return;
      }
      this.logList = this.logs[key];
    },
    init(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var d = {
        year: year,
        month: month,
        day: day
      }
      this.changeDay(d);
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.init(this.value);
  }
}
</script>
<style lang="stylus">
.vc-day-content {
  color: rgba(0,0,0,0.65);
}
.vc-text-white {
  color: $color-white !important;
}
.vc-weekday {
  color: rgba(0,0,0,0.65);
}
.vc-border-gray-400  {
  border-color: $color-gray-d9;
}
.vc-rounded-lg {
  border-radius: 4px;
}
.vc-svg-icon {
  color: $color-black-45;
}
.vc-arrows-container {
  border-bottom: 1px solid rgba(0,0,0,0.09);
}
.vc-header {
  margin-bottom: 16px;
}
.vc-title {
  font-size:14px;
  font-family:HelveticaNeue-Medium,HelveticaNeue;
  font-weight:500;
  color:$color-black-85;
  line-height 26px;
}
.vc-bg-custom-600 {
  background-color : $color-main;
}
.vc-rounded-full {
  border-radius:2px;
}
.vc-highlight {
  width: 24px !important;
  height: 24px !important;
}
</style>
<style lang="stylus" scoped>
.version {
  margin-right: -15px;
  padding: 30px 0;

  .calendar-view {
    width:280px;
    height:314px;
    position: fixed;
    top: 98px;
    left: 50%;
    margin-left: calc(-1336px / 2  + 215px);
  }
  .content-view {
    margin-left: 280px;
    background: $color-gray-fb;

    .content-card {
      padding: 24px;
      background-color : $color-white;
      .title {
        color: #030303;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
      }
      .content {
        margin-top: 16px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color: $color-black-65;
      }
    }
  }

  /deep/ .el-calendar {
    position: relative

    .el-calendar__title {
        text-align: center;
        width: 100%;
        line-height: 24px;
    }

    .el-calendar__body {
        padding-top: 0;
    }

    .el-calendar-table .el-calendar-day {
        padding: 6px 8px;
        text-align: center;
        height: 36px;
    }

    .el-calendar-table thead th {
        padding: 8px 0;
    }

    .el-calendar__button-group {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 7px;
        text-align: center;
        

        .el-button {
            padding: 4px 6px;
        }
    }
  }
}
</style>
